<template>
  <div class="modal false z-50 fixed w-full h-full top-0 left-0 flex items-center justify-center">
    <div class="absolute w-full h-full bg-gray-900 opacity-50 modal-overlay"></div>
    <div class="z-50 w-full p-8 mx-auto bg-white rounded shadow-lg modal-container md:max-w-4xl max-h-screen custom-scrollbar overflow-y-auto">
      <div class="modal__header">
        <span class="modal__side__close" @click="$emit('close')"><svg viewBox="0 0 20 20" width="20" height="20"><use xlink:href="@/assets/v2/img/sprite.svg#chevron__right"></use></svg></span>
      </div>
      <h3 class="modal__resolution__title">{{ section.name }}</h3>

      <Form class="modal__footer"
            @submit="submit">
        <!-- header -->
        <!-- body -->
        <div class="flex items-center">
          <div class="w-1/2 mr-3">
            <div class="input__group input__add__info">
              <label for="state-input" class="label">{{ $lang.app.SUBDIVISION }}</label>
              <div class="select__wrapper">
                <Field name="state" v-slot="{ field, errorMessage }">
                  <Multiselect
                      id="state-input"
                      :class="{'select--fail': errorMessage }"
                      v-bind="field"
                      v-model="state"
                      :options="helper.stateOptions"
                      :placeholder="$lang.app.SELECT_FROM_OPTIONS"
                      :searchable="true"
                      :noOptionsText="$lang.app.LIST_EMPTY"
                      :noResultsText="$lang.app.NOT_FOUND"
                      :can-clear="false">
                  </Multiselect>
                  <span v-if="errorMessage" class="input__fail">{{ errorMessage }}</span>
                </Field>
              </div>
            </div>
            <div class="input__group input__add__info">
              <label for="department-input" class="label">{{ $lang.app.DEPARTMENT }}</label>
              <div class="select__wrapper">
                <Field name="department" v-slot="{ field, errorMessage }">
                  <Multiselect
                      id="department-input"
                      :class="{'select--fail': errorMessage }"
                      v-bind="field"
                      v-model="department"
                      :options="helper.departmentOptions"
                      :placeholder="$lang.app.SELECT_FROM_OPTIONS"
                      :searchable="true"
                      :noOptionsText="$lang.app.LIST_EMPTY"
                      :noResultsText="$lang.app.NOT_FOUND"
                      :can-clear="false">
                  </Multiselect>
                  <span v-if="errorMessage" class="input__fail">{{ errorMessage }}</span>
                </Field>
              </div>
            </div>
          </div>
          <div v-if="defaultEmployees.length" class="w-1/2 ml-2">
            <div class="space__between">
              <div class="label">{{ $lang.app.LAST_SELECTED_EMPLOYEES }}</div>
            </div>
            <div class="add__users__list custom-scrollbar overflow-y-auto">
              <div v-for="employee in defaultEmployees" :key="employee.id" class="adding__user__item">
                <div class="input__group input__checkbox">
                  <input type="checkbox" :checked="form.employees.some(e => e.id === employee.id)"
                         class="checkbox"
                         @input="toggleEmployeeSelect(employee)">
                </div>
                <div class="resolution__user__info cursor-pointer" @click="toggleEmployeeSelect(employee)">
                  <div class="resolution__user__name">{{ employee.name }}</div>
                  <div class="text-xs text-blue-800">{{ employee.position }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <ExecutorsMultiselect
            :value="form.employees"
            :with-responsible="true"
            @update="form.employees = $event"
            :options="helper.employeeOptions"/>
        <div v-if="errorMessage" class="text-sm text-red-500">{{ errorMessage }}</div>

        <div class="between__buttons">
          <button type="button" @click="$emit('close')"
                  class="button button__modal__close button--cancel">{{ $lang.app.CANCEL }}</button>
          <button type="submit" class="button button__icon--left green__lighter button__modal__close">
            {{ this.$lang.app.SAVE }}
          </button>
        </div>
      </Form>
    </div>
  </div>
</template>
<script>
import {Field, Form} from 'vee-validate'

import stateApi from "../../../../../api/ref/state"
import employeeApi from "../../../../../api/employee/employee"

import ExecutorsMultiselect from "../../inputs/ExecutorsMultiselect"
import {getValueByKey as executorTypesGetValue} from "../../../../../helpers/constants/executorTypes"
import departmentApi from "../../../../../api/employee/department";

export default {
  props: {
    section: Object,
    defaultEmployees: Array,
    executors: Array,
  },
  components: {
    Field,
    Form,
    ExecutorsMultiselect
  },
  data() {
    return {
      state: null,
      department: null,
      form: {
        employees: this.executors.map(e => ({...e})),
      },
      helper: {
        stateOptions: [],
        departmentOptions: [],
        employeeOptions: [],
      },
      errorMessage: null,
    };
  },
  watch: {
    'state'(value) {
      if (value) {
        this.department = null
        this.setDepartmentOptions(value)
      }
    },
    'department'(value) {
      this.helper.employeeOptions = []
      if (value) {
        employeeApi.getEmployeesByDepartmentId(value).then((res) => {
          this.helper.employeeOptions = res.data?.map((item) => ({
            id: item.id,
            name: item.fullName,
            position: this.$lang.$translate({ru: item.position.nameRu, kg: item.position.nameKg}),
            type: this.executorTypesGetValue('EXECUTOR'),
            vacation: item.activeVacation,
          }));
        });
      }
    }
  },
  methods: {
    executorTypesGetValue,
    initStateOptions() {
      stateApi.getSubStates().then((res) => {
        this.helper.stateOptions = res.map(stateItem => ({
          value: stateItem.id,
          label: this.$lang.$translate({ru: stateItem.nameRu, kg: stateItem.nameKg}),
        }))
      })
    },
    setDepartmentOptions(value) {
      departmentApi.getActiveDepartmentsByStateId(value).then((res) => {
        this.helper.departmentOptions = res.map(departmentItem => ({
          value: departmentItem.id,
          label: this.$lang.$translate({ru: departmentItem.nameRu, kg: departmentItem.nameKg}),
        }))
      })
    },
    toggleEmployeeSelect(employee) {
      if (this.form.employees.some(e => e.id === employee.id)) {
        this.form.employees = this.form.employees.filter(e => e.id !== employee.id)
      } else {
        this.form.employees.push(employee)
      }
    },
    valid() {
      this.errorMessage = null
      if(!this.form.employees.some(e => e.type === this.executorTypesGetValue('RESPONSIBLE'))) {
        this.errorMessage = this.$lang.app.ASSIGN_RESPONSIBLE
        return false
      }
      return true
    },
    submit() {
      if(this.valid()) {
        this.$emit("submit", {
          section: this.section.section,
          employees: this.form.employees
        })
      }
    },
  },
  beforeMount() {
    this.initStateOptions()
  },
}
</script>
